export class CouponDtoModel {
    code?: string;
    discountType?: string;
    discountValue?: number;
    quantity?: number;
    quantityToDisplay?: number;
    used?: number;
    expiresAt?: any;
    uuid?: string;
}
